// Set the key we'll use in local storage.
// Go to Chrome dev tools, application tab, click "Local Storage" and "http://localhost:8080"
// and you'll see this key set below (if logged in):
import {
  CLEAR_ALL_DATA,
  UPDATE_AUTH,
  UPDATE_ROUTES,
  UPDATE_USER,
  SET_MEMBER,
  SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE,
  ADD_TO_CART,
  REMOVE_FROM_CART,
  SET_ID_CLUB_SELECTED,
  SET_CLUB,
  SET_GRADES,
  SET_MODE_PAYEMENT,
  SET_SOUS_MODE_PAYEMENT,
  SET_VALIDATED_CART,
  SET_ORDER_PAYED,
  SET_MODE_LIVRAISON,
  SET_STEP_ORDER,
  SET_ADRESS_FOR_ORDER,
  SET_ADRESS_FACTURATION_FOR_ORDER,
  SET_TITUL_CARD_NAME,
  SET_DATA_TO_SYNCEDDATA_VUEX,
  RESET_ORDER,
  SET_STRIPE_OBJECT,
  SET_STRIPE_CLIENT_SECRET_TOKEN,
  SET_STRIPE_PAYMENT_METHOD,
  SET_ID_ORDER,
  SET_CARD_INFO,
} from "./mutations-type";

export const STORAGE_KEY = 'abft_intranet'

var _ = require('lodash');

// initial state
const state = {
  syncedData: {
    auth: {
      isLoggedIn: false,
      accessToken: null,
      refreshToken: null
    },
    abft:{
      iban:"BE16 3400 0897 6174"
    },
    user: null,
    member: null,
    club: null,
    idClubSelected: null,
    grades: null,
    routes: [],
    cart: {},
    products: {},
    order: {
      id:null,
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      modePayement: null,
      sousModePayement: null,
      titulCardName: null,
      modeLivraison: null,
      validatedCart: false,
      orderPayed: false,
      orderValidated: false,
      adresseForOrder: {},
      adresseFacturationForOrder: {},
    }
  },
  notSyncedData: {
    appnav: {
      searchText: '',
      searchTimestamp: null
    },
    stripe: null,
    stripeClientSecretToken: null,
    stripePaymentMethod: null,
  },

}

// mutations
const mutations = {
  [CLEAR_ALL_DATA](state, message) {
    // console.log("CLEAR_ALL_DATA")
    // console.log(localStorage.getItem("abft_intranet"))
    localStorage.clear();
  },

  [UPDATE_USER](state, message) {
    state.syncedData.user = message;
  },
  [SET_DATA_TO_SYNCEDDATA_VUEX](state, message) {
    Object.assign(state.syncedData,message)
    // state.syncedData = message;
  },
  [SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE](state) {
    // console.log("SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE")
    // localStorage.setItem(STORAGE_KEY, JSON.stringify(state.syncedData))
    // console.log(localStorage.getItem("abft_intranet"))
  },
  [UPDATE_AUTH](state, message) {
    state.syncedData.auth = message;
  },
  [UPDATE_ROUTES](state, message) {
    state.syncedData.routes = message;
  },
  [SET_MEMBER](state, message) {
    state.syncedData.member = message;
  },
  [SET_CLUB](state, message) {
    state.syncedData.club = message;
  },
  [SET_GRADES](state, message) {
    state.syncedData.grades = message;
  },
  [SET_MODE_PAYEMENT](state, message) {
    state.syncedData.order.modePayement = message;
  },
  [SET_SOUS_MODE_PAYEMENT](state, message) {
    state.syncedData.order.sousModePayement = message;
  },
  [SET_MODE_LIVRAISON](state, message) {
    state.syncedData.order.modeLivraison = message;
  },
  [SET_VALIDATED_CART](state, message) {
    state.syncedData.order.validatedCart = message;
  },
  [SET_ORDER_PAYED](state, message) {
    state.syncedData.order.orderPayed = message;
  },
  [SET_ADRESS_FOR_ORDER](state, message) {
    state.syncedData.order.adresseForOrder = message;
  },
  [SET_ADRESS_FACTURATION_FOR_ORDER](state, message) {
    state.syncedData.order.adresseFacturationForOrder = message;
  },
  [SET_TITUL_CARD_NAME](state, message) {
    state.syncedData.order.titulCardName = message;
  },
  [SET_STRIPE_OBJECT](state, message) {
    state.notSyncedData.stripe = message;
  },
  [SET_STRIPE_CLIENT_SECRET_TOKEN](state, message) {
    state.notSyncedData.stripeClientSecretToken = message;
  },
  [SET_STRIPE_PAYMENT_METHOD](state, message) {
    state.notSyncedData.stripePaymentMethod = message;
  },
  [SET_STEP_ORDER](state, message) {
    state.syncedData.order[message.step] = message.value;
  },
  [SET_ID_ORDER](state, message) {
    state.syncedData.order.id = message;
  },
  [SET_ID_CLUB_SELECTED](state, message) {
    state.syncedData.idClubSelected = message;
  },
  [ADD_TO_CART](state, message) {
    // debugger

    if (!_.has(state.syncedData.cart, message.type))
      Vue.$set(state.syncedData.cart, message.type, {}) // Vue.$set pour la réactivité sinon elle n'est pas écoutée

    switch (message.type) {
      case 'licence_renew':
        if (!_.has(state.syncedData.cart[message.type], message.membre.id))
          Vue.$set(state.syncedData.cart[message.type], message.membre.id, {
            quantity: 1,
            price: 40,
            member: message.membre
          })
        break
      case 'licence_club':
        if (!_.has(state.syncedData.cart[message.type], message.id))
          Vue.$set(state.syncedData.cart[message.type], message.id, {
            quantity: 1,
            price: 50,
            club: message.club,
            id:message.id
          })
        break
    }
    // if (!_.has(state.syncedData.cart, message.id))
    //     Vue.$set(state.syncedData.cart, message.id, {quantity: 0})

    // state.syncedData.cart[message.id].quantity += message.quantity;
  },
  [REMOVE_FROM_CART](state, message) {
    if (!_.has(state.syncedData.cart, message.type + '.' + message.id))
      return
    else {
      Vue.$delete(state.syncedData.cart[message.type], message.id)
    }

  },
  [RESET_ORDER](state) {
    state.syncedData.cart = {}
    state.syncedData.products = {}
    state.syncedData.order = {
      id:null,
      step1: false,
      step2: false,
      step3: false,
      step4: false,
      step5: false,
      modePayement: null,
      sousModePayement: null,
      titulCardName: null,
      modeLivraison: null,
      validatedCart: false,
      orderPayed: false,
      orderValidated: false,
      adresseForOrder: {},
      adresseFacturationForOrder: {},
    }
    state.notSyncedData.stripePaymentMethod=null,
    state.notSyncedData.stripeClientSecretToken=null

  }
}

const actions = {
  addToCart({commit}, msg) {
    commit(ADD_TO_CART, msg)
  },
  removeFromCart({commit}, msg) {
    commit(REMOVE_FROM_CART, msg)
  },
  setMainUser({commit}, msg) {
    commit(UPDATE_USER, msg)
  },
  setRoutes({commit}, msg) {
    commit(UPDATE_ROUTES, msg)
  },
  setAuth({commit}, msg) {
    commit(UPDATE_USER, msg)
  },
  setMember({commit}, msg) {
    commit(SET_MEMBER, msg)
  },
  setIdClubSelected({commit}, msg) {
    commit(SET_ID_CLUB_SELECTED, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setClub({commit}, msg) {
    commit(SET_CLUB, msg)
  },
  setGrades({commit}, msg) {
    commit(SET_GRADES, msg)
  },
  setModePayement({commit}, msg) {
    commit(SET_MODE_PAYEMENT, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setSousModePayement({commit}, msg) {
    commit(SET_SOUS_MODE_PAYEMENT, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setModeLivraison({commit}, msg) {
    commit(SET_MODE_LIVRAISON, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setAdresseForOrder({commit}, msg) {
    commit(SET_ADRESS_FOR_ORDER, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setAdresseFacturationForOrder({commit}, msg) {
    commit(SET_ADRESS_FACTURATION_FOR_ORDER, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setTitulCardName({commit}, msg) {
    commit(SET_TITUL_CARD_NAME, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setValidatedCart({commit}, msg) {
    commit(SET_VALIDATED_CART, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setOrderPayed({commit}, msg) {
    commit(SET_ORDER_PAYED, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setIdOrder({commit}, msg) {
    commit(SET_ID_ORDER, msg)
  },
  setStepOrder({commit}, msg) {
    commit(SET_STEP_ORDER, msg)
    // commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setStripeObject({commit}, msg) {
    commit(SET_STRIPE_OBJECT, msg)
  },
  setStripeClientSecretToken({commit}, msg) {
    commit(SET_STRIPE_CLIENT_SECRET_TOKEN, msg)
  },
  setStripePaymentMethod({commit}, msg) {
    commit(SET_STRIPE_PAYMENT_METHOD, msg)
  },

  setAllDataToLocalStorage({commit}) {
    commit(SET_ALL_SYNCEDDATA_TO_LOCAL_STORAGE)
  },
  setDataToSyncedDataVuex({commit}) {
    commit(SET_DATA_TO_SYNCEDDATA_VUEX)
  },
  resetOrder({commit}) {
    commit(RESET_ORDER)
  },

}

const getters = {
  getMainUser: state => {
    return state.syncedData.user;
  },
  getAbft: state => {
    return state.syncedData.abft;
  },
  getModePayement: state => {
    return state.syncedData.order.modePayement;
  },
  getTitulCardName: state => {
    return state.syncedData.order.titulCardName;
  },
  getSousModePayement: state => {
    return state.syncedData.order.sousModePayement;
  },
  getIdClubSelected: state => {
    return state.syncedData.idClubSelected
  },
  getIdOrder: state => {
    return state.syncedData.order.id
  },
  getCart: state => {
    return state.syncedData.cart;
  },
  getGrades: state => {
    return state.syncedData.grades;
  },
  getClub: state => {
    return state.syncedData.club;
  },
  getAuth: state => {
    return state.syncedData.auth;
  },
  getRoutes: state => {
    return state.syncedData.routes
  },
  getMember: state => {
    return state.syncedData.member;
  },
  getOrder: state => {
    return state.syncedData.order;
  },

  getStripeObject: state => {
    return state.notSyncedData.stripe;
  },
  getStripeClientSecretToken: state => {
    return state.notSyncedData.stripeClientSecretToken;
  },
  getStripePaymentMethod: state => {
    return state.notSyncedData.stripePaymentMethod;
  },
  getRoute(state) {
    let self = this;
    return function (routeName) {
      return process.env.API_URL + state.syncedData.routes[routeName];
    };
  },
  getAllDataFromLocalStorage() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY));
  },
  // getSyncLocalStorage: state => {
  //   if (localStorage.getItem(STORAGE_KEY)) {
  //     state.syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY))
  //   }
  //   return Object.assign(state.syncedData, state.notSyncedData);
  // },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/local-storage.js